import { StepperIndexes } from "@repo/logic";

import { QuestionnairePages, QuestionnairePagesType } from "../PensionQuestionnaire/Questions";
import { AMLIdentificationIntroPage } from "./AMLIdentificationIntroPage";
import { AMLIdentificationPage } from "./AMLIdentificationPage";
import { BankIdentificationPage } from "./BankIdentificationPage";
import { ChangeContributionOverviewPage } from "./ChangeContributionOverviewPage";
import { ChangeContributionPage } from "./ChangeContributionPage";
import { ChangeContributionRecapPage } from "./ChangeContributionRecapPage";
import { ChangePensionContributionStepExtraProps } from "./ChangePensionContribution.types";
import { RequestSentPage } from "./RequestSentPage";

// This is the set of possible steps, actual step list is in the redux state
export const ChangePensionContributionPages: QuestionnairePagesType<ChangePensionContributionStepExtraProps> = {
    [StepperIndexes.bankIdentificationPage]: BankIdentificationPage,
    [StepperIndexes.amlIdentificationPage]: AMLIdentificationPage,
    [StepperIndexes.amlIdentificationIntroPage]: AMLIdentificationIntroPage,
    [StepperIndexes.changeContributionPage]: ChangeContributionPage,
    [StepperIndexes.changeContributionOverviewPage]: ChangeContributionOverviewPage,
    [StepperIndexes.changeContributionRecapPage]: ChangeContributionRecapPage,
    [StepperIndexes.changeContributionRequestSentPage]: RequestSentPage,
    ...QuestionnairePages,
    // Add other pages here as needed
};
